import React, { FC } from 'react';

import HomePageTrendingIdea from '@buyside/components/presentation/HomePage/HomePageTrendingIdeas/homePageTrendingIdea';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import { times } from '@buyside/util/lodashAlt';

import { useHomePageTrendingIdeasQuery } from '@interfaces/graphql-typings';

import styles from './homePageTrendingIdeasStyles.scss';

const HomePageTrendingIdeas: FC = () => {
  const { data, loading } = useHomePageTrendingIdeasQuery();

  return (
    <div className={styles.trendingContainer}>
      <header>Trending Reports</header>
      <div className={styles.trendingIdeasWrapper}>
        <div className={styles.trendingIdeasScrollContainer}>
          <div className={styles.trendingIdeasTrack}>
            {loading
              ? times(20).map(i => (
                  <div key={i} className={styles.trendingIdea}>
                    <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
                  </div>
                ))
              : null}
            {data?.trendingIdeas?.edges?.map(edge => {
              if (!edge?.node) return null;

              return <HomePageTrendingIdea key={`trending-idea-${edge.node.id}`} {...edge.node} />;
            })}
            {data?.trendingIdeas?.edges?.map(edge => {
              if (!edge?.node) return null;

              return (
                <HomePageTrendingIdea key={`dup-trending-idea-${edge.node.id}`} {...edge.node} />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageTrendingIdeas;
